export const getEnvVars = ({ envVars }) => envVars;
